import { useQuery } from "react-query";
import firebase from '../../constants/firebase'

const db = firebase.firestore()

const useCurrentUser = (uid) => {
    const getCurrentUser = () => {
        return db.collection("users").doc(uid).get().then((doc) => {
            return doc.data()
        })
    }
    return useQuery({
        queryKey: 'currentUser',
        queryFn: getCurrentUser,
        refetchOnWindowFocus: false,
        //query will not autoFetch until page refresh:
        staleTime: Infinity,
    })
}

export default useCurrentUser